<template>
  <section class="section-hero section-shaped my-0">
    <div class="shape shape-circuit">
      <Circuit></Circuit>
    </div>
    <div class="container shape-container d-flex align-items-center">
      <div class="col px-0">
        <div class="row justify-content-center align-items-center">
          <div class="col-lg-7 text-center">
            <img
              src="img/brand/aldtek/ald_logo.png"
              style="width: 200px;"
              class="img-fluid"
            />
            <p class="lead text-white mt-4 mb-0 circuit-text">
              A digital playground of technology.
            </p>
            <p class="lead text-white mt-0 mb-5 circuit-text">
              Showcase of 3D printing and web development projects.
            </p>
          </div>
        </div>
      </div>
    </div>
    <div>
      <ScrollDown></ScrollDown>
    </div>
  </section>
</template>
<script>
import ScrollDown from "./aldtek/animatedIcons/ScrollDown.vue";
import Circuit from "./aldtek/animations/Circuit.vue";

export default {
  components: {
    ScrollDown,
    Circuit
  }
};
</script>

<style lang="scss" scoped>
$blue-100: #8798fa;
$blue-200: darken($blue-100, 8%);
$blue-300: darken($blue-200, 8%);
$blue-400: darken($blue-300, 8%);
$blue-500: darken($blue-400, 8%);
$blue-600: darken($blue-500, 8%);
$blue-700: darken($blue-600, 8%);
$blue-800: darken($blue-700, 8%);
$blue-900: darken($blue-800, 8%);

.shape-circuit {
  background: linear-gradient($blue-900 15%, $blue-700 80%, $blue-600 94%);
}

.circuit-text {
  text-shadow: 2px 0 3px black, -2px 0 3px black, 0 -2px 3px black,
    0 2px 3px black;
}
</style>
